module.exports = __webpack_public_path__ + "e491dd0b992bbc132130dab9362eb36e.svg";